import React, { useState } from 'react'
import LoginPageHeader from '../../components/Headers/HeaderV2025/LoginPageHeader';
import {useParams,Link, useNavigate} from "react-router-dom";
import "./RegistrationPage.css";
import Footer from '../../components/Footer/Footer';
import StickyNotification from '../../components/StickyNotification/StickyNotification';
import RegistrationForm from '../../components/RegistrationForm/RegistrationForm';
import * as translator from "../../utils/translator";
import UspBarV2025 from '../../components/UspBarV2025/UspBarV2025';

const RegistrationPage = () => {

  const {country} = useParams();
  const language = translator.getLanguageByCountry(country);
  const navigate = useNavigate();
  const [stickyNotificationDetails, setStickyNotificationDetails] = useState({ // global state for sticky handling
    show: false,
    title: "",
    content: "",
    level : "",
    showInfoIcon:true,
    refresh:false,
  });

  // HL-10259: Read Apple Sign In query params so the registration form can pre-fill
  // the Apple-verified email and name. The customer sets their own password
  // as in the regular registration flow.
  const queryParams = new URLSearchParams(window.location.search);
  const appleSignInSource = queryParams.get("source") === "apple_sign_in" ? "apple_sign_in" : null;
  const appleSignInEmail = queryParams.get("email") ?? "";
  const appleSignInFirstName = queryParams.get("firstName") ?? "";
  const appleSignInLastName = queryParams.get("lastName") ?? "";
  
  if(language){

  
  return (
    <>
    <div className="registration-page">
       <UspBarV2025 />
       <div className="bg-black">
        <div className="rounded-t-[30px] overflow-hidden">
          <LoginPageHeader breadcrumbLabel={translator.translate(language, "authentication", 'header/registration')} />
        </div>
       </div>
       
  

        <StickyNotification
            showNotification={stickyNotificationDetails.show}
            title={stickyNotificationDetails.title}
            onClick={() => setStickyNotificationDetails((currentDetails:any) => { return {...currentDetails, show:false}})}  
            content={stickyNotificationDetails.content}
            level={stickyNotificationDetails.level}
            showInfoIcon={stickyNotificationDetails.showInfoIcon}
            refresh={stickyNotificationDetails.refresh}
        />

        <div id="registration-content-container" className="pt-[30px] pb-[50px]">
          <div className="registration-content">
            <div className="registration-form-container">

              <h2 id="registration-form-title" className="font-semibold leading-[1.2] text-[22px] md:text-[32px] text-center mb-[6px] md:mb-[12px] linear-text-color-primary">
                {translator.translate(language, "authentication", 'RegistrationPage/registration_form_title')}
              </h2>

              <span id="registration-form-subtitle" className="text-[16px] leading-[1.2] md:text-[22px] font-regular font-poppins text-center mb-[32px]" >
                {translator.translate(language, "authentication", 'RegistrationPage/registration_form_subtitle')}
              </span>


              <RegistrationForm
                languageProp={language}
                redirectPath={`${country}/register`}
                cameFromPath={`${country}/register`}
                navigationCallback={()=> {
                const redirectParam = new URLSearchParams(window.location.search).get('redirect');
                if (redirectParam) {
                  navigate(decodeURIComponent(redirectParam));
                } else {
                  navigate(`/${country}/account/personal-data`);
                }
              }}
                setStickyNotificationDetails={setStickyNotificationDetails}
                submitButtonPlaceholder={
                translator.translate(
                  language,
                  "authentication",
                  "RegistrationPage/submit_button_text"
                )}
                openedTooltipsRef={undefined}
                userClicksRef={undefined}
                isCannabisCatalog={false}
                appleSignInSource={appleSignInSource}
                appleSignInEmail={appleSignInEmail}
                appleSignInFirstName={appleSignInFirstName}
                appleSignInLastName={appleSignInLastName}
              />
            
              <span id="already-a-customer" className="text-[16px] text-[#08080A] text-center mt-[16px]">
                 {translator.translate(language, "authentication", 'RegistrationPage/already_a_customer')}
                <Link to={`/${country}/login`} className="ml-[0.4em] linear-text-color-primary !no-underline hover:!no-underline">
                  {translator.translate(language, "authentication", 'RegistrationPage/login_here')}
                </Link>
              </span>
            </div>
          </div>
        </div>
        <Footer page="RegistrationPage" language={language} />  
    </div>
    </>
  )
  } else {
    return <></>
  }
}

export default RegistrationPage